import { useEffect, useState } from "react";
import type { OriginalInfo } from "../../types";
import type { AddressChangeInfo } from "../Address/types";
import { useAppDispatch, useAppSelector } from "../../redux";
import {
  confirmContactInfoAction,
  getContactInfoAction,
  selectAddress,
  selectContactEmail,
  selectCurrectInfo,
  selectIsUpdatedAddress,
  selectPhone,
  selectRegNum,
} from "./ContactInfoSlice";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import { selectPaneemStatus } from "../../AppSlice";
import { selectEmail } from "../InfoPage/InfoPageSlice";

export function useContactInfo() {
  const phone = useAppSelector(selectPhone);
  const email = useAppSelector(selectContactEmail);
  const text = useAppSelector(selectText);
  const status = useAppSelector(selectPaneemStatus);
  const regNum = useAppSelector(selectRegNum);
  const paneemEmail = useAppSelector(selectEmail);
  const isAddressUpdated = useAppSelector(selectIsUpdatedAddress);
  const originalInfo = useAppSelector(selectCurrectInfo);

  const address = useAppSelector(selectAddress);

  const dispatch = useAppDispatch();

  const [type, setType] = useState<string | null>(null);
  const [modal, setmodal] = useState<boolean>(true);
  const [errMsg, setErrMsg] = useState<string | null>(null);

  useEffect(() => {
    if (email || phone) {
      setErrMsg(null);
    }
  }, [email, phone]);

  useEffect(() => {
    const start = async () => {
      async function getData() {
        if (regNum && status === "approved") {
          await dispatch(getContactInfoAction({ regNum, lan: text.language }));
        }
      }

      await getData();
    };

    start();
  }, []);

  const edit = (type: string) => {
    setType(type);
    setmodal(true);
  };

  const confirmContactInfo = async () => {
    if (!originalInfo || !address) {
      return;
    }
    if (!email && !phone) {
      setErrMsg(text.email_or_phone_requered);
      return;
    }

    const updatedInfo = collectUpdatedInfo(originalInfo, {
      email,
      phone,
      address,
      isAddressUpdated,
    });

    const args = {
      contactInfo: originalInfo,
      updatedContactInfo: updatedInfo,
      paneemEmail: paneemEmail,
      lan: text.language,
    };

    await dispatch(confirmContactInfoAction(args));
  };

  return { edit, type, modal, setmodal, confirmContactInfo, errMsg };
}

export function collectUpdatedInfo(
  originalInfo: OriginalInfo,
  updateInfo: {
    email: string | null;
    phone: string | null;
    address: AddressChangeInfo;
    isAddressUpdated: boolean;
  }
) {
  let address;

  if (!updateInfo.isAddressUpdated) {
    address = {
      street1: originalInfo.ADD_LINE1,
      street2: originalInfo.ADD_LINE2,
      city: originalInfo.Claimant_Current_City,
      state: originalInfo.Claimant_Current_State,
      country: originalInfo.ISO_Country,
      zipcode: originalInfo.Claimant_Current_Zip_Code,
    };
  } else {
    let street2 = `Building ${updateInfo.address.building}`;
    if (updateInfo.address?.apt !== "") {
      street2 = street2 + ` Apt ${updateInfo.address?.apt}`;
    }
    address = {
      street1: updateInfo.address.street,
      street2: street2,
      city: updateInfo.address.city,
      state: updateInfo.address.state,
      country: updateInfo.address.country,
      zipcode: updateInfo.address.zipcode,
    };
  }

  const updatedContactInfo = {
    email: updateInfo.email === "" ? null : updateInfo.email,
    phone: updateInfo.phone === "" ? null : updateInfo.phone,
    address: address,
  };

  return updatedContactInfo;
}
